// Arabic M3 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enM3 } from './en-m3.ts';
import type { Message } from './types.ts';

export const arM3: { readonly [K in keyof typeof enM3]: Message } = {
  'api.walkInsDisabled': 'تسجيل الزيارات دون موعد متوقف وفق سياسة هذا الموقع.',
  'api.notWalkIn': 'لم تُسجَّل هذه الزيارة كزيارة دون موعد.',
  'api.evaluationStale': 'تغيّرت تفاصيل الزائر بعد مراجعتك لها. راجع الفحوصات الحالية وحاول مجددًا.',
  'api.arrivalBlocked': 'لا يمكن تسجيل هذا الوصول بعد. عالج الفحوصات المذكورة أو سجّل الزائر كمنتظر.',
  'api.notOnsite': 'هذا الزائر غير مسجّل كموجود في الموقع.',
  'api.alreadyOnsite': 'هذا الزائر مسجّل بالفعل كموجود في الموقع.',
  'api.alreadyWaiting': 'هذا الزائر في الانتظار بالفعل.',
  'api.waitingResolved': 'انتهى هذا الانتظار بالفعل.',
  'api.custodyTransition': 'لا يمكن نقل البطاقة من {from} إلى {to}.',
  'api.cardUnavailable': 'هذه البطاقة لم تعد متاحة. حُدّث المخزون.',
  'api.cardAlreadyAssigned': 'يحمل هذا الزائر بطاقة بالفعل. أعِدها أولًا.',
  'api.cardNotAssignable': 'تُسند البطاقة فقط لزائر معتمد في زيارة قائمة.',
  'api.noCardAssigned': 'لا يحمل هذا الزائر أي بطاقة.',
  'api.badgeNotAllowed': 'تُطبع الشارة فقط لزائر معتمد في زيارة قائمة.',
  'api.taskResolved': 'هذه المهمة محلولة بالفعل.',
  'v.observedFuture': 'لا يمكن أن يكون الوقت في المستقبل.',
  'v.observedBeforeArrival': 'لا يمكن أن تكون المغادرة قبل الوصول المسجّل.',
  'v.cardNumber': 'استخدم من 1 إلى 40 حرفًا أو رقمًا أو نقطة أو شرطة.',
  'v.cardNumberTaken': 'رقم البطاقة هذا مستخدم لبطاقة أخرى في هذا الموقع.',
  'v.cardUnknown': 'اختر بطاقة تابعة لهذا الموقع.',
  'v.reprintReason': 'اذكر سبب إعادة الطباعة.',
  'v.notEditable': 'لا يمكن تغيير هذه المعلومة هنا. تواصل مع مضيفك.',
  'v.noticeUnknown': 'هذا الإشعار ليس جزءًا من زيارتك.',
  'v.signatureRequired': 'اكتب اسمك الكامل للتوقيع.',
  'v.documentType': 'استخدم ملف PDF أو JPEG أو PNG.',
  'custody.available': 'متاحة',
  'custody.assigned': 'مُسندة',
  'custody.returned_held': 'أُعيدت (محتجزة)',
  'custody.lost': 'مفقودة',
  'custody.disabled': 'معطلة',
  'custody.maintenance': 'قيد الصيانة',

  'rcp.title': 'الاستقبال',
  'rcp.intro': 'اعرف من هو متوقع، وعالج العوائق، وسجّل الحركة الفعلية.',
  'rcp.walkIn': 'تسجيل زائر دون موعد',
  'rcp.date': 'اليوم',
  'rcp.today': 'اليوم',
  'rcp.pastNote': 'يُعرض الحضور كما كان في نهاية {date}، وليس حضور اليوم.',
  'rcp.m.expected': 'متوقعون',
  'rcp.m.expectedSub': 'لم يُرصدوا اليوم بعد',
  'rcp.m.waiting': 'في الانتظار',
  'rcp.m.waitingSub': 'وصلوا ولم يُسمح لهم بالدخول بعد',
  'rcp.m.onsite': 'رُصدوا في الموقع',
  'rcp.m.onsiteSub': 'حضور، وليس صلاحية دخول مستنتجة',
  'rcp.m.exceptions': 'استثناءات',
  'rcp.m.exceptionsSub': 'متجاوزون للوقت أو لم يصلوا',
  'rcp.lookup': 'البحث عن زائر',
  'rcp.lookupHint': 'امسح رمز QR للبطاقة، أو اكتب المرجع (V-…) أو رقم البطاقة أو الاسم أو المضيف أو الجهة.',
  'rcp.lookupGo': 'بحث',
  'rcp.lookupNone': 'لا يوجد زائر مطابق في هذا الموقع.',
  'rcp.lookupDead': 'رابط البطاقة هذا لم يعد صالحًا. اطلب من الزائر أحدث دعوة أو ابحث عنه بالاسم.',
  'rcp.tab.expected': 'الوصول المتوقع',
  'rcp.tab.waiting': 'في الانتظار',
  'rcp.tab.onsite': 'في الموقع',
  'rcp.tab.departed': 'غادروا',
  'rcp.tab.exceptions': 'استثناءات',
  'rcp.queue': 'قائمة الاستقبال',
  'rcp.queueSub': 'تحقق من الهوية والموافقات والتسجيل المسبق قبل الوصول.',
  'rcp.empty': 'لا أحد في هذه القائمة.',
  'rcp.col.visitor': 'الزائر',
  'rcp.col.window': 'النافذة',
  'rcp.col.host': 'المضيف',
  'rcp.col.requirements': 'المتطلبات',
  'rcp.col.presence': 'الحضور / الوصول',
  'rcp.col.action': 'الإجراء التالي',
  'rcp.review': 'مراجعة وإجراء',
  'rcp.flag.walkIn': 'دون موعد',
  'rcp.flag.early': 'مبكر',
  'rcp.flag.late': 'متأخر',
  'rcp.bucket.overdue': 'تجاوز الوقت — لا مغادرة مسجّلة',
  'rcp.bucket.not_arrived': 'لم يصل',
  'rcp.card': 'بطاقة {number}',
  'rcp.waitingSince': 'ينتظر منذ {time} · {reason}',
  'rcp.rsvp.declined': 'اعتذر عن الحضور',
  'rcp.handover': 'تسليم المناوبة',
  'rcp.handoverSub': 'العمل المفتوح يتبع السجل وليس الموظف.',
  'rcp.handoverNone': 'لا مهام مفتوحة.',
  'rcp.handoverAck': 'تأكيد استلام المناوبة',
  'rcp.handoverNote': 'ملاحظة التسليم',
  'rcp.handoverDone': 'أُكّد التسليم مع {count} مهام مفتوحة.',
  'rcp.handoverLast': 'آخر تسليم: {by}، {when}',
  'rcp.task.waiting': 'زائر في الانتظار',
  'rcp.task.card_missing': 'بطاقة لم تُعَد',
  'rcp.task.overstay': 'تجاوز الوقت — لا مغادرة مسجّلة',
  'rcp.task.print_unknown': 'نتيجة طباعة الشارة غير معروفة',
  'rcp.task.departure_unconfirmed': 'المغادرة غير مؤكدة',
  'rcp.task.other': 'أخرى',
  'rcp.taskResolve': 'حل',
  'rcp.taskResolution': 'ما الذي تم',
  'rcp.d.title': '{name}',
  'rcp.d.sub': '{reference} · المضيف {host}',
  'rcp.d.checks': 'فحوصات الوصول',
  'rcp.d.checksOk': 'كل الفحوصات المطلوبة ناجحة.',
  'rcp.d.checksNote': 'تُعاد الفحوصات عند تسجيل الوصول.',
  'rcp.d.window': 'النافذة',
  'rcp.d.arrive': 'تسجيل الوصول',
  'rcp.d.observedAt': 'وقت الرصد (اختياري)',
  'rcp.d.observedHint': 'اتركه فارغًا للوقت الحالي. استخدمه فقط لتسجيل لحظة حدثت بالفعل.',
  'rcp.d.wait': 'تسجيل كمنتظر',
  'rcp.d.waitReason': 'ينتظر',
  'rcp.d.waitChange': 'تغيير السبب',
  'rcp.d.waitEnd': 'إنهاء الانتظار',
  'rcp.d.waitEnded': 'غادر الزائر',
  'rcp.d.card': 'البطاقة الفعلية',
  'rcp.d.cardNone': 'لا توجد بطاقة مُسندة.',
  'rcp.d.cardAssign': 'إسناد بطاقة',
  'rcp.d.cardChoose': 'بطاقة متاحة',
  'rcp.d.cardReturn': 'أُعيدت البطاقة',
  'rcp.d.cardLost': 'تسجيل البطاقة مفقودة',
  'rcp.d.cardLostReason': 'ماذا حدث',
  'rcp.d.badge': 'الشارة',
  'rcp.d.badgePrint': 'طباعة الشارة',
  'rcp.d.badgeReprint': 'إعادة طباعة الشارة',
  'rcp.d.badgeReason': 'سبب إعادة الطباعة',
  'rcp.d.badgeAttempts': { one: 'طباعة واحدة · الأخيرة: {status}', two: 'طباعتان · الأخيرة: {status}', few: '{count} طبعات · الأخيرة: {status}', many: '{count} طبعة · الأخيرة: {status}', other: '{count} طبعة · الأخيرة: {status}' },
  'rcp.d.depart': 'تسجيل المغادرة',
  'rcp.d.departCard': 'البطاقة {number}',
  'rcp.d.departCard.returned': 'أُعيدت',
  'rcp.d.departCard.not_returned': 'لم تُعَد',
  'rcp.d.departCard.lost': 'مفقودة',
  'rcp.d.departNote': 'تُسجَّل المغادرة حتى لو بقيت بطاقة أو إلغاء صلاحية مفتوحًا.',
  'rcp.d.history': 'الحركات المرصودة',
  'rcp.d.historyNone': 'لا حركات مسجّلة.',
  'rcp.d.recordedBy': 'سجّلها {name} في {when}',
  'rcp.d.arrival': 'وصول',
  'rcp.d.departure': 'مغادرة',
  'rcp.d.openVisit': 'فتح الزيارة',
  'rcp.blocker.visit_not_submitted': 'الزيارة غير مقدَّمة.',
  'rcp.blocker.visit_cancelled': 'الزيارة ملغاة.',
  'rcp.blocker.visit_ended': 'انتهت الزيارة.',
  'rcp.blocker.participant_removed': 'أُزيل هذا الشخص من الزيارة.',
  'rcp.blocker.approval_pending': 'الموافقة ما زالت معلّقة.',
  'rcp.blocker.approval_rejected': 'رُفضت الموافقة.',
  'rcp.blocker.host_confirmation_pending': 'لم يؤكد المضيف هذه الزيارة دون موعد بعد.',
  'rcp.blocker.window_not_open': 'لم تبدأ نافذة الزيارة بعد.',
  'rcp.blocker.window_ended': 'انتهت نافذة الزيارة.',
  'rcp.blocker.already_onsite': 'مسجّل بالفعل كموجود في الموقع.',
  'rcp.blocker.reentry_not_allowed': 'غادر بالفعل؛ والسياسة لا تسمح بإعادة الدخول.',
  'rcp.blocker.presence_unknown': 'الحضور غير مؤكد؛ عالج التعارض أولًا.',
  'rcp.warning.early': 'وصول مبكر.',
  'rcp.warning.identity_evidence_missing': 'لا يوجد إثبات هوية مقبول (فحوصات الهوية تأتي مع الوحدة 08).',
  'rcp.warning.attendance_declined': 'أفاد الزائر بأنه لا يستطيع الحضور.',
  'rcp.blocker.contractor_not_eligible': 'شروط المقاول غير مستوفاة (الإثباتات أو الانتساب أو الإيقاف أو التصريح). راجع جاهزية المقاول في الزيارة.',
  'rcp.blocker.preregistration_incomplete': 'التسجيل المسبق غير مكتمل وهذه الفئة تشترطه قبل الوصول.',
  'rcp.warning.preregistration_incomplete': 'التسجيل المسبق غير مكتمل.',
  'rcp.reason.host': 'المضيف',
  'rcp.reason.approval': 'الموافقة',
  'rcp.reason.escort': 'المرافق',
  'rcp.reason.evidence': 'الإثبات',
  'rcp.reason.other': 'أخرى',
  'badge.title': 'شارة الزائر',
  'badge.visitor': 'زائر',
  'badge.host': 'المضيف',
  'badge.validUntil': 'صالحة حتى',
  'badge.print': 'طباعة',
  'badge.outcome': 'هل طُبعت الشارة؟',
  'badge.outcome.sent': 'أُرسلت للطابعة',
  'badge.outcome.printed': 'طُبعت',
  'badge.outcome.failed': 'فشلت',
  'badge.outcome.unknown': 'غير متأكد',
  'badge.note': 'الطباعة لا تُصدر أي تصريح دخول.',
  'walk.title': 'تسجيل زائر دون موعد',
  'walk.sub': 'تخضع الزيارات دون موعد للسياسة والموافقات نفسها. يؤكد المضيف قبل الوصول.',
  'walk.host': 'المضيف',
  'walk.category': 'فئة الزائر',
  'walk.purpose': 'الغرض',
  'walk.destination': 'الوجهة',
  'walk.until': 'متوقع أن يغادر بحلول',
  'walk.untilHint': 'اليوم، بتوقيت الموقع. الافتراضي نهاية اليوم.',
  'walk.visitor': 'الزائر',
  'walk.returning': 'زائر عائد؟',
  'walk.useProfile': 'استخدام هذا الملف',
  'walk.create': 'تسجيل',
  'walk.confirmTitle': 'زائر دون موعد بانتظارك',
  'walk.confirmBody': 'سجّل الاستقبال هذا الزائر دون دعوة مسبقة. أكّد أنك تتوقعه.',
  'walk.confirm': 'تأكيد الزيارة',
  'walk.confirmed': 'أُكّدت {when}',
  'cards.title': 'الشارات والوصول',
  'cards.intro': 'تُتابع حيازة البطاقات الفعلية بشكل منفصل عن صلاحية الوصول. لا يُعاد استخدام البطاقة المرتجعة إلا بعد تأكيد إيقاف صلاحيتها.',
  'cards.inventory': 'مخزون البطاقات',
  'cards.add': 'إضافة بطاقة',
  'cards.number': 'رقم البطاقة',
  'cards.label': 'التسمية',
  'cards.col.card': 'البطاقة',
  'cards.col.custody': 'الحيازة',
  'cards.col.holder': 'لدى',
  'cards.col.action': 'الإجراء',
  'cards.disable': 'تعطيل',
  'cards.maintenance': 'إرسال للصيانة',
  'cards.enable': 'جعلها متاحة',
  'cards.empty': 'لا توجد بطاقات مسجّلة لهذا الموقع.',
  'cards.logical': 'تصاريح الوصول المنطقية وتكامل أنظمة التحكم بالدخول تأتي مع الوحدة 11.',

  // التسجيل المسبق للزائر (الوحدة 05، PD-035).
  'prereg.title': 'قبل زيارتك',
  'prereg.requiredBeforeArrival': 'يُرجى إكمال هذه الخطوات قبل وصولك. لا يمكن للاستقبال تسجيل وصولك قبل إتمامها.',
  'prereg.optionalBeforeArrival': 'إكمال هذه الخطوات الآن يوفر الوقت عند الاستقبال.',
  'prereg.complete': 'اكتمل كل شيء',
  'prereg.outstanding': 'المتبقي: {count}',
  'prereg.status.complete': 'تم',
  'prereg.status.pending': 'مطلوب',
  'prereg.status.declined': 'مرفوض منك',
  'prereg.status.rejected': 'غير مقبول',
  'prereg.status.expired': 'منتهي الصلاحية',
  'prereg.status.unavailable': 'لا يمكن التحقق منه بعد',
  'prereg.status.review_pending': 'قيد التحقق',
  'prereg.contact': 'بيانات الاتصال الخاصة بك',
  'prereg.name': 'الاسم',
  'prereg.email': 'البريد الإلكتروني',
  'prereg.phone': 'الهاتف',
  'prereg.organisation': 'الجهة',
  'prereg.maskedHint': 'البريد الإلكتروني والهاتف مخفيان جزئيًا لأن هذا الرابط قد تتم مشاركته. لتغييرهما، اكتب القيمة الجديدة كاملة.',
  'prereg.contactCorrect': 'هذه البيانات صحيحة',
  'prereg.contactChange': 'تغيير البيانات',
  'prereg.saveContact': 'حفظ وتأكيد',
  'prereg.field.givenName': 'الاسم الأول',
  'prereg.field.familyName': 'اسم العائلة',
  'prereg.field.email': 'البريد الإلكتروني الجديد',
  'prereg.field.phone': 'رقم الهاتف الجديد',
  'prereg.field.organisation': 'الجهة',
  'prereg.noticeUnavailable': 'لم يُنشر هذا الإشعار بعد. سيتواصل معك مضيفك.',
  'prereg.noticeVersion': 'الإصدار {number}',
  'prereg.purpose': 'سبب الطلب',
  'prereg.signedName': 'اكتب اسمك الكامل للتوقيع',
  'prereg.signedNameHint': 'يُسجَّل اسمك المكتوب وإصدار الإشعار والوقت بوصفها توقيعك.',
  'prereg.sign': 'توقيع',
  'prereg.accept': 'قرأت وأوافق',
  'prereg.declineNotice': 'لا أوافق',
  'prereg.declinedHint': 'لقد رفضت هذا الإشعار. سيرى مضيفك والاستقبال أنه غير مقبول. يمكنك قبوله لاحقًا إذا غيرت رأيك.',
  'prereg.chooseFile': 'اختر ملفًا',
  'prereg.replaceFile': 'استبدال الملف',
  'prereg.fileHint': 'PDF أو JPEG أو PNG، حتى 10 ميغابايت.',
  'prereg.upload': 'رفع',
  'prereg.uploading': 'جارٍ الرفع…',
  'prereg.doc.complete': 'مقبول.',
  'prereg.doc.review_pending': 'تم الاستلام وبانتظار التحقق.',
  'prereg.doc.unavailable': 'تم الاستلام، لكن لا يمكن التحقق من المستندات بعد في هذا الموقع. سيساعدك الاستقبال عند وصولك.',
  'prereg.doc.rejected': 'لم يُقبل هذا المستند. يُرجى رفع مستند جديد.',
  'prereg.doc.expired': 'انتهت صلاحية هذا المستند. يُرجى رفع مستند ساري.',
  'prereg.doc.declined': 'مرفوض.',
  'prereg.readiness': 'التسجيل المسبق',
  'prereg.readiness.complete': 'مكتمل',
  'prereg.readiness.outstanding': 'المتبقي: {count}',

  // محرر السياسة: التسجيل المسبق (PD-035) وقواعد الاستقبال (PD-030)؛ الإشعارات (PB-05-03/04).
  'vpolicy.col.preRegistration': 'قبل الوصول',
  'vpolicy.pr.title': 'التسجيل المسبق للزائر',
  'vpolicy.pr.hint': 'ما يُكمله الزوار في هذه الفئة من رابط تصريحهم قبل الوصول.',
  'vpolicy.pr.confirmContact': 'يؤكد الزائر بيانات الاتصال',
  'vpolicy.pr.requiredBeforeArrival': 'يجب الإكمال قبل أن يسجّل الاستقبال الوصول',
  'vpolicy.pr.editable': 'البيانات التي يمكن للزائر تصحيحها',
  'vpolicy.pr.field.email': 'البريد الإلكتروني',
  'vpolicy.pr.field.phone': 'الهاتف',
  'vpolicy.pr.field.organisation': 'الجهة',
  'vpolicy.pr.field.name': 'الاسم',
  'vpolicy.pr.nameWarning': 'يُسجَّل تغيير الاسم من الزائر بوصفه متعلقًا بالهوية ويجب التحقق منه عند الاستقبال.',
  'vpolicy.pr.notices': 'الإشعارات المطلوب قبولها أو توقيعها',
  'vpolicy.pr.noNotices': 'لا توجد إشعارات بعد. أنشئ إشعارًا في قسم الإشعارات أدناه.',
  'vpolicy.pr.noticeMissing': 'غير منشور',
  'vpolicy.pr.documents': 'المستندات المطلوب رفعها',
  'vpolicy.pr.docKey': 'مفتاح المستند',
  'vpolicy.pr.docRequired': 'مطلوب',
  'vpolicy.pr.addDocument': 'إضافة مستند',
  'vpolicy.pr.removeDocument': 'إزالة',
  'vpolicy.pr.scannerNote': 'تبقى المستندات المرفوعة بحالة «لا يمكن التحقق منه بعد» حتى يُهيّأ فاحص للبرمجيات الضارة ومراجع، لذا سيبقى المستند المطلوب سببًا في عدم اكتمال الزيارة.',
  'vpolicy.pr.contactShort': 'تأكيد الاتصال',
  'vpolicy.pr.noticesShort': 'إشعارات: {count}',
  'vpolicy.pr.documentsShort': 'مستندات: {count}',
  'vpolicy.pr.requiredShort': 'مطلوب قبل الوصول',
  'vpolicy.rcp.title': 'قواعد الاستقبال',
  'vpolicy.rcp.early': 'أبكر وصول قبل بدء الفترة',
  'vpolicy.rcp.grace': 'مهلة تجاوز البقاء بعد انتهاء الفترة',
  'vpolicy.rcp.minutesHint': 'بالدقائق.',
  'vpolicy.rcp.minutes': '{count} دقيقة',
  'vpolicy.rcp.reentry': 'السماح بإعادة الدخول بعد المغادرة ضمن الفترة نفسها',
  'vpolicy.rcp.walkIns': 'تسجيل الزوار دون موعد',
  'vpolicy.rcp.hostConfirm': 'يتطلب الزائر دون موعد تأكيد المضيف قبل الوصول',
  'vpolicy.rcp.walkInsConfirm': 'نعم، مع تأكيد المضيف',
  'notice.title': 'الإشعارات',
  'notice.intro': 'نصوص بإصدارات يقبلها الزوار أو يوقعونها. لا تتغير الإصدارات المنشورة؛ انشر إصدارًا جديدًا بدلًا من ذلك.',
  'notice.new': 'إشعار جديد',
  'notice.newVersion': 'إصدار جديد',
  'notice.newVersionOf': 'إصدار جديد من {key}',
  'notice.draftHint': 'يُحفظ مسودة. لا يراه الزوار إلا بعد نشره.',
  'notice.empty': 'لا توجد إشعارات بعد.',
  'notice.col.notice': 'الإشعار',
  'notice.col.kind': 'النوع',
  'notice.kind.acknowledgement': 'إقرار',
  'notice.kind.signature': 'توقيع',
  'notice.status.draft': 'مسودة',
  'notice.status.published': 'منشور',
  'notice.status.retired': 'مُستبدل',
  'notice.siteOnly': 'لهذا الموقع فقط',
  'notice.publish': 'نشر',
  'notice.key': 'المفتاح',
  'notice.keyHint': 'أحرف لاتينية صغيرة وأرقام وشرطات. تشير السياسة إلى الإشعارات بالمفتاح.',
  'notice.bodyEn': 'النص (بالإنجليزية)',
  'notice.bodyAr': 'النص (بالعربية)',
  'notice.purpose': 'سبب الحاجة إلى التوقيع',
  'notice.purposeHint': 'يظهر للزائر مع طلب التوقيع.',
  'notice.reaccept': 'يجب على من قبلوا إصدارًا سابقًا قبول هذا الإصدار مجددًا',
  'notice.saveDraft': 'حفظ المسودة',

  // كشك الخدمة الذاتية (الوحدة 05، PD-040، PD-041).
  'api.kioskNotPaired': 'هذه الشاشة غير مهيأة ككشك. اطلب من مسؤول الموقع إقرانها.',
  'api.kioskPairingInvalid': 'رمز الإقران غير صالح أو منتهي الصلاحية.',
  'api.kioskRevoked': 'تم إلغاء هذا الكشك.',
  'api.kioskHostUnknown': 'اختر أحد المضيفين المتاحين في هذا الكشك.',
  'api.kioskSessionEnded': 'انتهت هذه الجلسة. يُرجى البدء من جديد.',
  'api.kioskFeatureOff': 'هذا الخيار غير متاح في هذا الكشك.',
  'api.kioskPaused': 'هذا الكشك متوقف لبضع دقائق. يُرجى التوجه إلى الاستقبال.',
  'api.kioskNotFound': 'لم نتمكن من العثور على زيارتك. تحقق من البيانات أو اطلب المساعدة من الاستقبال.',
  'api.kioskChanged': 'تغيرت تفاصيل زيارتك. يُرجى مراجعتها والمحاولة مرة أخرى.',
  'api.kioskSeeReception': 'يُرجى التوجه إلى الاستقبال لإتمام وصولك.',
  'v.pairingCode': 'أدخل الرمز المكوّن من 8 خانات، مثل ABCD-2345.',
  'v.reference': 'أدخل المرجع الظاهر في تصريحك، مثل V-8FD8C5.',
  'rcp.task.kiosk_assistance': 'طلب مساعدة من كشك',
  'rcp.task.kiosk_walk_in': 'طلب زيارة دون موعد من كشك',

  // شاشات الكشك (PB-05-09..12، OR-04).
  'kiosk.pair.title': 'إعداد هذا الكشك',
  'kiosk.pair.body': 'أدخل رمز الإقران الذي أنشأه مسؤول الموقع من المواقع ← الأكشاك.',
  'kiosk.pair.code': 'رمز الإقران',
  'kiosk.pair.submit': 'إقران هذه الشاشة',
  'kiosk.eyebrow': '{site} · أهلاً بك',
  'kiosk.welcome.title': 'أهلاً بك. سجّل وصولك هنا.',
  'kiosk.welcome.body': 'اختر لغتك ثم اتبع الخطوات. الاستقبال جاهز دائمًا لمساعدتك.',
  'kiosk.language': 'اللغة',
  'kiosk.checkIn': 'لدي دعوة',
  'kiosk.checkOut': 'أنا مغادر',
  'kiosk.walkIn': 'ليست لدي دعوة',
  'kiosk.help': 'أحتاج إلى مساعدة',
  'kiosk.privacy': 'تُمسح هذه الشاشة تلقائيًا بعد {count} ثانية من عدم النشاط. لا يُحفظ أي شيء تدخله على هذا الجهاز.',
  'kiosk.find.titleIn': 'ابحث عن دعوتك',
  'kiosk.find.titleOut': 'تسجيل المغادرة',
  'kiosk.find.body': 'امسح رمز QR الموجود في تصريحك، أو أدخل مرجع زيارتك.',
  'kiosk.find.scan': 'امسح تصريحك',
  'kiosk.find.scanPlaceholder': 'قرّب رمز QR من الماسح',
  'kiosk.find.camera': 'استخدام الكاميرا',
  'kiosk.find.cameraFailed': 'تعذّر استخدام الكاميرا. أدخل مرجعك بدلًا من ذلك أو اطلب المساعدة.',
  'kiosk.find.continue': 'متابعة',
  'kiosk.find.orReference': 'أو أدخل مرجعك',
  'kiosk.find.reference': 'مرجع الزيارة (في تصريحك)',
  'kiosk.find.checkName': 'اسمك الأول أو اسم العائلة',
  'kiosk.find.checkPhone': 'آخر 4 أرقام من رقم هاتفك',
  'kiosk.back': 'رجوع',
  'kiosk.cancel': 'إلغاء',
  'kiosk.finish': 'إنهاء',
  'kiosk.hello': 'مرحبًا، {name}.',
  'kiosk.reference': 'المرجع',
  'kiosk.confirmIn': 'سجّل وصولي الآن',
  'kiosk.confirmOut': 'سجّل مغادرتي الآن',
  'kiosk.cardReturn': 'يُرجى تسليم بطاقة الزائر إلى الاستقبال أو وضعها في صندوق البطاقات.',
  'kiosk.req.body': 'قبل تسجيل وصولك، يُرجى قراءة ما يلي والرد عليه.',
  'kiosk.req.reception': 'بعض الخطوات لا يمكن إكمالها إلا مع الاستقبال. يُرجى طلب المساعدة.',
  'kiosk.outcome.too_early': 'لقد وصلت مبكرًا.',
  'kiosk.outcome.too_early_body': 'يُتاح تسجيل الوصول الذاتي قبل {time} بقليل. يُرجى الجلوس أو مراجعة الاستقبال.',
  'kiosk.outcome.ended': 'هذه الزيارة لم تعد سارية.',
  'kiosk.outcome.already_onsite': 'تم تسجيل وصولك مسبقًا.',
  'kiosk.outcome.see_reception': 'يُرجى مراجعة الاستقبال.',
  'kiosk.outcome.not_onsite': 'لم يتم تسجيل وصولك.',
  'kiosk.outcome.requirements': 'تبقّت بضع خطوات.',
  'kiosk.outcome.ready': 'جاهز.',
  'kiosk.outcome.checked_in': 'تم تسجيل الوصول.',
  'kiosk.outcome.checked_out': 'تم تسجيل المغادرة.',
  'kiosk.outcome.reception': 'سيساعدك الاستقبال على إتمام وصولك. يمكنك طلب المساعدة أدناه.',
  'kiosk.done.inTitle': 'أهلاً بك، {name}. تم تسجيل وصولك.',
  'kiosk.done.inBody': 'يجري إبلاغ {host} بوصولك.',
  'kiosk.done.badge': 'يُرجى استلام شارة الزائر من الاستقبال.',
  'kiosk.done.outTitle': 'شكرًا لزيارتك، {name}.',
  'kiosk.done.card': 'يُرجى إعادة بطاقة الزائر إلى الاستقبال.',
  'kiosk.helpComing': 'تم إبلاغ الاستقبال وسيكون معك قريبًا.',
  'kiosk.idle.title': 'هل ما زلت هنا؟',
  'kiosk.idle.body': { one: 'حفاظًا على خصوصيتك ستُمسح هذه الشاشة خلال ثانية واحدة.', two: 'حفاظًا على خصوصيتك ستُمسح هذه الشاشة خلال ثانيتين.', few: 'حفاظًا على خصوصيتك ستُمسح هذه الشاشة خلال {count} ثوانٍ.', other: 'حفاظًا على خصوصيتك ستُمسح هذه الشاشة خلال {count} ثانية.' },
  'kiosk.idle.continue': 'متابعة',
  'kiosk.walkin.body': 'أخبرنا بمن جئت لمقابلته. سيسجّل الاستقبال زيارتك مع مضيفك.',
  'kiosk.walkin.host': 'من تزور؟',
  'kiosk.walkin.purpose': 'سبب الزيارة',
  'kiosk.walkin.submit': 'إرسال إلى الاستقبال',
  'kiosk.doneNote.help': 'المساعدة في الطريق.',
  'kiosk.doneNote.helpBody': 'تم إبلاغ الاستقبال. يُرجى الانتظار هنا أو التوجه إلى المكتب.',
  'kiosk.doneNote.walkin': 'شكرًا لك. وصل طلبك إلى الاستقبال.',
  'kiosk.doneNote.walkinBody': 'يُرجى الجلوس. سيتواصل الاستقبال مع مضيفك ويساعدك على تسجيل الوصول.',
  'kiosk.doneNote.ended': 'انتهت هذه الجلسة.',
  'kiosk.doneNote.endedBody': 'حفاظًا على خصوصيتك تم مسح الشاشة. يُرجى البدء من جديد.',
  // المواقع ← الأكشاك (الإدارة).
  'sites.tab.kiosks': 'الأكشاك',
  'kiosks.title': 'أكشاك الخدمة الذاتية',
  'kiosks.intro': 'شاشات مشتركة يسجّل فيها الزوار وصولهم. يُقرن كل كشك مرة واحدة برمز ويمكن إلغاؤه في أي وقت.',
  'kiosks.add': 'إضافة كشك',
  'kiosks.empty': 'لا توجد أكشاك في هذا الموقع.',
  'kiosks.col.kiosk': 'الكشك',
  'kiosks.col.status': 'الحالة',
  'kiosks.col.offers': 'الخدمات',
  'kiosks.col.seen': 'آخر ظهور',
  'kiosks.idle': 'يُمسح بعد {seconds} ث',
  'kiosks.status.pending': 'بانتظار الإقران',
  'kiosks.status.active': 'نشط',
  'kiosks.status.revoked': 'ملغى',
  'kiosks.offer.checkIn': 'تسجيل الوصول',
  'kiosks.offer.checkout': 'تسجيل المغادرة الذاتي',
  'kiosks.offer.walkIn': 'طلبات الزيارة دون موعد',
  'kiosks.offer.notices': 'الإشعارات',
  'kiosks.settings': 'الإعدادات',
  'kiosks.newCode': 'رمز إقران جديد',
  'kiosks.revoke': 'إلغاء',
  'kiosks.editTitle': 'إعدادات الكشك: {name}',
  'kiosks.dialogHint': 'تُطبّق التغييرات عند تحميل الكشك التالي (خلال خمس دقائق).',
  'kiosks.name': 'الاسم',
  'kiosks.nameHint': 'مكان الشاشة، مثل «الردهة، المدخل الشرقي».',
  'kiosks.defaultLocale': 'لغة البدء',
  'kiosks.lookupCheck': 'التحقق الثاني مع المرجع المكتوب',
  'kiosks.lookupCheckHint': 'المرجع وحده لا يعثر على أي زيارة.',
  'kiosks.lookup.name': 'الاسم الأول أو اسم العائلة',
  'kiosks.lookup.phone_last4': 'آخر 4 أرقام من الهاتف',
  'kiosks.idleSeconds': 'مسح الشاشة بعد',
  'kiosks.warningSeconds': 'التنبيه قبل المسح',
  'kiosks.secondsHint': 'بالثواني.',
  'kiosks.offersLegend': 'ما يقدمه هذا الكشك',
  'kiosks.escalate': 'التحويل إلى الاستقبال بدلًا من التسجيل الذاتي عندما',
  'kiosks.badge': 'بعد تسجيل الوصول',
  'kiosks.badge.collect_at_reception': 'اطلب من الزائر استلام الشارة من الاستقبال',
  'kiosks.badge.none': 'دون رسالة عن الشارة',
  'kiosks.walkInHosts': 'المضيفون المتاحون لطلبات الزيارة دون موعد',
  'kiosks.walkInHostsHint': 'تظهر هذه الأسماء فقط في الكشك؛ ولا يظهر أي جزء آخر من الدليل.',
  'kiosks.createAndPair': 'إنشاء وعرض رمز الإقران',
  'kiosks.pairTitle': 'إقران {name}',
  'kiosks.pairHint': 'يُعرض الرمز مرة واحدة ويعمل لمدة 30 دقيقة.',
  'kiosks.pairStep1': 'على شاشة الكشك، افتح',
  'kiosks.pairStep2': 'أدخل هذا الرمز:',
  'kiosks.pairValid': 'صالح حتى {time}',
  'kiosks.pairOnce': 'الإقران مجددًا لاحقًا يستبدل بيانات اعتماد الجهاز وينهي أي جلسة زائر مفتوحة.',
  'kiosks.pairDone': 'تم',
  'kiosks.revokeTitle': 'إلغاء {name}',
  'kiosks.revokeHint': 'يتوقف الكشك عن العمل فورًا وتنتهي أي جلسة زائر مفتوحة.',
  'kiosks.revokeReason': 'السبب',

  // الاتصالات (الوحدة 13، PD-045..PD-048).
  'api.alreadyVoted': 'سبق أن اتخذت قرارًا بشأن هذه الموافقة.',
  'v.groupUnknown': 'اختر مجموعة موافقين نشطة.',
  'v.groupEmpty': 'لا توجد أعضاء في مجموعة الموافقين هذه، لذا لا يمكن البت في المرحلة أبدًا.',
  'v.policyTimerOrder': 'يجب أن يسبق التصعيد انتهاء الصلاحية.',
  'v.delegateSelf': 'اختر شخصًا غير الشخص المفوِّض.',
  'v.delegationTooLong': 'لا يمكن أن يتجاوز التفويض 90 يومًا.',
  'api.delegationRevoked': 'تم إلغاء هذا التفويض مسبقًا.',
  'specialist.protocol-officer': 'مسؤول المراسم',
  'v.escortConfirm': 'أكّد حضور المرافق قبل تسجيل الوصول.',
  'rcp.blocker.escort_unassigned': 'يتطلب هذا النوع من الزوار مرافقًا، ولم يُعيَّن أحد.',
  'rcp.warning.escort_confirmation': 'المرافق مطلوب: أكّد حضوره.',
  'v.hostInactive': 'اختر مضيفًا نشطًا.',
  'v.templateVariable': 'متغيرات غير معروفة لهذا القالب: {names}.',
  'v.channelNotUsed': 'لا ترسل هذه المؤسسة رسائل عبر هذه القناة.',
  'v.providerTemplate': 'استخدم اسم قالب المزوّد: أحرف لاتينية صغيرة وأرقام وشرطات سفلية.',
  'tpl.status.draft': 'مسودة',
  'tpl.status.approved': 'معتمد',
  'tpl.status.retired': 'مُستبدل',

  // مساحة الاتصالات وقواعد الإشعارات (الوحدة 13).
  'comms.title': 'الاتصالات',
  'comms.intro': 'قوالب الرسائل بالعربية والإنجليزية وسجل الإرسال. تُحدَّد القنوات لكل حدث في السياسات وسير العمل.',
  'comms.scope': 'ينطبق على',
  'comms.tabs': 'طرق عرض الاتصالات',
  'comms.tab.templates': 'القوالب',
  'comms.tab.log': 'سجل الإرسال',
  'comms.templates': 'قوالب الرسائل',
  'comms.templatesSub': 'تحل نسخ المؤسسة أو الموقع محل النص المدمج بعد اعتمادها. تُعتمد كل لغة على حدة.',
  'comms.newTemplate': 'قالب جديد',
  'comms.newVersion': 'إصدار جديد',
  'comms.newVersionOf': 'إصدار جديد: {name}',
  'comms.draftHint': 'يُحفظ مسودة. لا يراه المستلمون إلا بعد اعتماده.',
  'comms.empty': 'لا توجد قوالب للمؤسسة بعد؛ النصوص المدمجة مستخدمة.',
  'comms.emptySite': { zero: 'لا توجد قوالب خاصة بالموقع؛ تنطبق هنا نصوص المؤسسة أو النصوص المدمجة.', one: 'لا توجد قوالب خاصة بالموقع؛ ينطبق هنا قالب واحد للمؤسسة.', two: 'لا توجد قوالب خاصة بالموقع؛ ينطبق هنا قالبان للمؤسسة.', few: 'لا توجد قوالب خاصة بالموقع؛ تنطبق هنا {count} قوالب للمؤسسة.', many: 'لا توجد قوالب خاصة بالموقع؛ ينطبق هنا {count} قالبًا للمؤسسة.', other: 'لا توجد قوالب خاصة بالموقع؛ ينطبق هنا {count} قالب للمؤسسة.' },
  'comms.noTemplateScope': 'يمكنك عرض سجل الإرسال دون إدارة القوالب.',
  'comms.perLocale': 'اعتماد لغة لا يعتمد الأخرى أبدًا. إذا لم توجد نسخة معتمدة أو مدمجة بلغة المستلم، تُحجب الرسالة ما لم تُحدَّد لغة بديلة في السياسة.',
  'comms.col.message': 'الرسالة',
  'comms.col.channel': 'القناة',
  'comms.col.language': 'اللغة',
  'comms.col.inUse': 'المستخدم',
  'comms.col.draft': 'المسودة',
  'comms.col.time': 'الوقت',
  'comms.col.recipient': 'المستلم',
  'comms.col.status': 'الحالة',
  'comms.col.attempts': 'المحاولات',
  'comms.version': 'الإصدار {number}',
  'comms.builtIn': 'مدمج',
  'comms.segments': { zero: 'لا مقاطع', one: 'مقطع رسالة واحد', two: 'مقطعا رسالة', few: '{count} مقاطع رسائل', many: '{count} مقطعًا', other: '{count} مقطع' },
  'comms.approve': 'اعتماد',
  'comms.subject': 'الموضوع',
  'comms.bodyText': 'النص',
  'comms.bodyWhatsapp': 'معاملات القالب (بالترتيب)',
  'comms.bodyHtml': 'HTML (اختياري)',
  'comms.bodyHtmlHint': 'اتركه فارغًا لإرسال النص ضمن التصميم القياسي.',
  'comms.variables': 'المتغيرات: {names}',
  'comms.providerTemplate': 'اسم قالب المزوّد',
  'comms.providerTemplateHint': 'اسم القالب المعتمد لدى مزوّد واتساب. لا يُرسل نص حر أبدًا.',
  'comms.note': 'ملاحظة التغيير',
  'comms.preview': 'معاينة',
  'comms.previewTitle': 'معاينة ببيانات نموذجية',
  'comms.unknownVariables': 'متغيرات غير معروفة: {names}. سيُرفض الحفظ.',
  'comms.smsPreview': { one: 'مقطع واحد · {units} حرفًا · {per} لكل مقطع · {encoding}. يُرسل النص كاملًا دائمًا دون قص.', other: 'المقاطع: {count} · {units} حرفًا · {per} لكل مقطع · {encoding}. يُرسل النص كاملًا دائمًا دون قص، وقد يُحتسب كل مقطع.' },
  'comms.whatsappPreviewHint': 'يرسل واتساب قالب المزوّد مع هذه القيم كمعاملات بهذا الترتيب.',
  'comms.saveDraft': 'حفظ المسودة',
  'comms.log': 'سجل الإرسال',
  'comms.logSub': 'ما حدث لكل رسالة. المستلمون مخفيون جزئيًا.',
  'comms.site': 'الموقع',
  'comms.allStatuses': 'كل الحالات',
  'comms.logEmpty': 'لا توجد رسائل لهذا الموقع بعد.',
  'comms.acceptedNote': '«مقبولة» تعني أن المزوّد استلم الرسالة، ولا تعني أنها قُرئت، ولا تعني أبدًا اعتماد زيارة أو وصول.',
  'comms.key.invitation': 'دعوة',
  'comms.key.reminder': 'تذكير',
  'comms.key.cancellation': 'إلغاء',
  'comms.key.host_arrival': 'إشعار وصول للمضيف',
  'comms.key.rsvp_reply': 'رد الحضور للمضيف',
  'comms.key.approval_requested': 'طلب موافقة',
  'comms.key.approval_decided': 'نتيجة الموافقة للمضيف',
  'comms.key.parking_change': 'تغيير الموقف',
  'comms.key.gate_host_contact': 'تواصل البوابة مع المضيف',
  'comms.channel.email': 'البريد الإلكتروني',
  'comms.channel.sms': 'رسالة نصية',
  'comms.channel.whatsapp': 'واتساب',
  'comms.status.queued': 'في الانتظار',
  'comms.status.accepted': 'مقبولة',
  'comms.status.failed': 'فشلت',
  'comms.status.blocked': 'محجوبة',
  'comms.reason.no_consent': 'لا توجد موافقة من الزائر',
  'comms.reason.template_unapproved': 'لا يوجد قالب مزوّد معتمد',
  'comms.reason.template_locale_missing': 'لا توجد نسخة بلغة المستلم',
  'comms.reason.channel_unavailable': 'لا يوجد مزوّد مهيأ لهذه القناة',
  'comms.reason.opted_out': 'ألغى الزائر الاشتراك في هذه القناة',
  'comms.reason.superseded': 'صدر رابط أحدث',
  'vpolicy.ntf.title': 'الإشعارات',
  'vpolicy.ntf.hint': 'القنوات المستخدمة لكل حدث. تحتاج الرسائل النصية وواتساب إلى مزوّد (لم يُختر بعد)؛ وحتى ذلك تُسجَّل تلك الرسائل محجوبة.',
  'vpolicy.ntf.categoryTitle': 'الإشعارات لهذه الفئة',
  'vpolicy.ntf.categoryHint': 'حدّد «تجاوز» لتغيير حدث لهذه الفئة فقط؛ وإلا يُطبَّق إعداد المؤسسة.',
  'vpolicy.ntf.trigger': 'الحدث',
  'vpolicy.ntf.override': 'تجاوز',
  'vpolicy.ntf.overrideFor': 'تجاوز {name}',
  'vpolicy.ntf.on': 'مفعّل',
  'vpolicy.ntf.onFor': 'إرسال {name}',
  'vpolicy.ntf.staff': 'للموظفين',
  'vpolicy.ntf.visitor': 'للزائر',
  'vpolicy.ntf.t.invitation': 'الدعوة',
  'vpolicy.ntf.t.reminder': 'تذكير قبل الزيارة',
  'vpolicy.ntf.t.cancellation': 'الإلغاء',
  'vpolicy.ntf.t.host_arrival': 'وصول الزائر',
  'vpolicy.ntf.t.rsvp_reply': 'رد الزائر على الحضور',
  'vpolicy.ntf.t.approval_requested': 'مطلوب موافقة',
  'vpolicy.ntf.t.approval_decided': 'نتيجة الموافقة',
  'vpolicy.ntf.reminderHours': 'إرسال التذكير قبل هذا العدد من الساعات',
  'vpolicy.ntf.reminderHoursHint': 'بين 1 و168.',
  'vpolicy.ntf.fallback': 'إذا كانت نسخة اللغة مفقودة',
  'vpolicy.ntf.fallbackHint': 'افتراضيًا تُحجب هذه الرسالة بدلًا من إرسالها بلغة أخرى.',
  'vpolicy.ntf.fallbackNone': 'حجب الرسالة',
  'vpolicy.ntf.providerNote': 'واتساب للزوار الذين وافقوا فقط، وبقالب مزوّد معتمد فقط. لا تُرسل إشعارات الموظفين عبر واتساب أبدًا.',
  'pass.consent.title': 'تفضيلات الرسائل',
  'pass.consent.intro': 'يمكنك أيضًا تلقي تحديثات هذه الزيارة عبر:',
  'pass.consent.sms': 'رسالة نصية (SMS)',
  'pass.consent.whatsapp': 'واتساب',
  'pass.consent.saved': 'تم الحفظ.',

  // سير عمل الموافقات (الوحدة 07، PD-049..PD-053).
  'vpolicy.addFromTemplate': 'إضافة من قالب بداية',
  'vpolicy.chooseTemplate': 'اختر نوع زائر…',
  'vpolicy.templatesHint': 'القوالب نقاط بداية فقط: يبقى كل شيء قابلًا للتعديل ويُحفظ بإصدارات مع السياسة.',
  'vpolicy.quorum': 'عدد الموافقات المطلوبة',
  'vpolicy.quorumHint': 'أشخاص مختلفون يجب أن يوافقوا؛ ورفض واحد يكفي للرفض.',
  'vpolicy.escalateAfter': 'تنبيه المنسقين بعد',
  'vpolicy.expiresAfter': 'انتهاء الصلاحية بعد',
  'vpolicy.hoursOptional': 'ساعات انتظار القرار؛ اتركه فارغًا دون حد.',
  'vpolicy.resolver.groups': 'مجموعات الموافقين',
  'vpolicy.resolver.group': 'مجموعة',
  'vpolicy.resolver.people': 'أشخاص محددون',
  'vpolicy.typeHandling': 'معالجة هذا النوع من الزوار',
  'vpolicy.escortRequired': 'يحتاج إلى مرافق يُؤكَّد حضوره عند الوصول',
  'vpolicy.restrictedVisibility': 'رؤية مقيدة (المضيفون والموافقون والاستقبال ومسؤولو المراسم فقط)',
  'vpolicy.kioskSelfService': 'يمكنه استخدام أكشاك الخدمة الذاتية',
  'vpolicy.typeHandlingHint': 'هذه الإعدادات لا تتجاوز أبدًا الموافقة أو الهوية أو فحوص الوصول الأخرى.',
  'wf.choose': 'اختر…',
  'wf.quorumProgress': 'الموافقات: {done} من {of}',
  'wf.escalated': 'متأخرة',
  'wf.groupStage': 'المجموعة: {name}',
  'wf.actingFor': 'قرار نيابة عن {name}',
  'wf.alreadyVoted': 'اتخذت قرارك',
  'wf.groups.title': 'مجموعات الموافقين',
  'wf.groups.intro': 'من يوافق على أي زيارات حسب الموقع أو قسم المضيف أو الوجهة أو نوع الزائر. يمكن إسناد المراحل إلى مجموعة.',
  'wf.groups.new': 'مجموعة جديدة',
  'wf.groups.empty': 'لا توجد مجموعات موافقين بعد.',
  'wf.groups.noMembers': 'لا أعضاء',
  'wf.groups.memberCount': { zero: 'لا أعضاء', one: 'عضو واحد', two: 'عضوان', few: '{count} أعضاء', many: '{count} عضوًا', other: '{count} عضو' },
  'wf.groups.addMember': 'إضافة عضو',
  'wf.groups.addTo': 'إضافة إلى {name}',
  'wf.groups.scopeHint': 'اترك حقل النطاق فارغًا ليشمل كل شيء. يجب أن يحمل الشخص أيضًا دور الموافق في مكان الزيارة.',
  'wf.groups.col.person': 'الشخص',
  'wf.groups.col.scope': 'ينطبق على',
  'wf.groups.col.canDecide': 'يمكنه البت',
  'wf.groups.noApproverRole': 'لا يحمل دور الموافق',
  'wf.groups.remove': 'إزالة',
  'wf.groups.hint': 'لا يمكن نشر سياسة فيها مرحلة مسندة إلى مجموعة فارغة أو غير معروفة. لا يبت المضيفون والمنشئون أبدًا في زياراتهم.',
  'wf.scope.anySite': 'أي موقع',
  'wf.scope.siteLabel': 'الموقع',
  'wf.scope.department': 'القسم {name}',
  'wf.scope.departmentLabel': 'قسم المضيف',
  'wf.scope.departmentHint': 'يطابق قسم المضيف الرئيسي.',
  'wf.scope.location': 'ضمن {name}',
  'wf.scope.type': 'النوع {code}',
  'wf.scope.typeLabel': 'رمز نوع الزائر',
  'wf.scope.typeHint': 'مثل business أو contractor.',
  'wf.del.title': 'التفويضات أثناء الغياب',
  'wf.del.intro': 'اسمح لموافق آخر بالبت نيابة عنك خلال فترة. لا يتصرف إلا حيث يحق له الموافقة بنفسه.',
  'wf.del.new': 'تفويض موافقاتي',
  'wf.del.empty': 'لا توجد تفويضات.',
  'wf.del.col.from': 'المفوِّض',
  'wf.del.col.to': 'المفوَّض',
  'wf.del.col.when': 'الفترة',
  'wf.del.active': 'نشط',
  'wf.del.inactive': 'غير نشط',
  'wf.del.revoked': 'ملغى',
  'wf.del.revoke': 'إلغاء',
  'wf.del.from': 'من',
  'wf.del.until': 'حتى',
  'wf.del.save': 'تفويض',
  'wf.del.dialogHint': 'حتى 90 يومًا. تُسجَّل القرارات على أنها اتُّخذت نيابة عنك.',
  'wf.del.reason': 'السبب',
  'wf.del.reasonHint': 'يُسجَّل في سجل التدقيق، مثل الإجازة السنوية.',
  'wf.del.hint': 'لا يمكن للمفوَّض أبدًا البت في زيارة يستضيفها أو أنشأها، حتى نيابة عن غيره.',
  'wf.escort.title': 'المرافق',
  'wf.escort.required': 'يحتاج هذا النوع من الزوار إلى مرافق؛ ويؤكد الاستقبال حضوره عند الوصول.',
  'wf.escort.optional': 'يوجد مرافق محدد لهذه الزيارة.',
  'wf.escort.assign': 'تحديد مرافق',
  'wf.escort.change': 'تغيير المرافق',
  'wf.escort.none': 'لم يُحدَّد مرافق بعد. ينتظر الزائر في الاستقبال حتى يُحدَّد.',
  'wf.escort.since': 'منذ {when}',
  'wf.escort.person': 'المرافق',
  'wf.escort.dialogHint': 'يُحتفظ بالمرافق السابق، إن وُجد، في السجل.',
  'wf.escort.confirmPresent': 'المرافق حاضر لاستقبال الزائر',
  // قاموس الإعدادات (OR-10، PD-055/PD-056).
  'v.siteUnknown': 'اختر أحد مواقعك.',
  'v.purposeCodeTaken': 'هذا الرمز مستخدم بالفعل في هذا النطاق.',
  'v.purposeUnknown': 'اختر غرضًا من القائمة لهذا الموقع ونوع الزائر.',
  'v.purposeRetired': 'تم إيقاف هذا الغرض. اختر غرضًا حاليًا.',
  'v.personOtherSite': 'هذا الشخص معروف في موقع آخر، وهذا الموقع لا يعيد استخدام الملفات من مواقع أخرى. أضفه كزائر جديد.',
  'v.guidanceEmpty': 'املأ نوعًا واحدًا على الأقل من الإرشادات.',
  'v.locationUnknown': 'اختر موقعًا في هذا الموقع.',
  'api.guidanceRetired': 'تم استبدال هذه الإرشادات أو إيقافها بالفعل.',
  'api.noPolicyOverride': 'لا توجد لهذا الموقع سياسة خاصة؛ فهو يتبع السياسة المشتركة بالفعل.',
  'api.siteContextMismatch': 'هذا السجل يخص موقعًا غير موقع عملك الحالي. انتقل إلى موقعه وحاول مرة أخرى، أو ابدأ من جديد في موقع عملك.',
  'api.impactChanged': 'تغيّر شيء منذ مراجعتك للأثر (مثل حجز جديد). راجعه مرة أخرى.',
  'api.locationDependencies': 'انقل الزيارات المخططة إليه وعطّل ربط مناطق الدخول أولًا.',
  'api.locationPolicyReferences': 'أكّد أن القواعد المدرجة لهذا الموقع ستتوقف عن التطبيق.',
  'v.deskUnknown': 'اختر مكتبًا نشطًا في هذا الموقع.',
  'v.purposeFromList': 'يُختار غرض زوار هذا النوع من القائمة.',
  // Organisation configuration (OR-10, PD-055/PD-056).
  'cfg.tab': 'إعدادات المؤسسة',
  'cfg.title': 'إعدادات المؤسسة',
  'cfg.intro': 'القوائم المرجعية التي يستخدمها Passage، وأين تُدار كل منها، والقيم المحفوظة هنا. تبقى القيم الموقوفة في السجل؛ لا يُحذف شيء.',
  'cfg.areas.title': 'القوائم المرجعية',
  'cfg.areas.intro': 'تُعدَّل كل قائمة في مكانها وبصلاحياته. تعرضها هذه الصفحة معًا.',
  'cfg.col.area': 'القائمة',
  'cfg.col.current': 'الحالي',
  'cfg.col.managed': 'تُدار في',
  'cfg.col.action': 'الإجراء',
  'cfg.manage': 'إدارة',
  'cfg.view': 'عرض',
  'cfg.edit': 'تعديل',
  'cfg.area.sites': 'الشركة والمواقع',
  'cfg.area.sites.hint': 'المواقع والعناوين والدول والمناطق الزمنية والهوية البصرية.',
  'cfg.area.sites.summary': '{active} نشطة · {inactive} غير نشطة',
  'cfg.area.categories': 'أنواع الزوار',
  'cfg.area.categories.hint': 'الفئات والبيانات المطلوبة ومراحل الموافقة (سياسة بإصدارات).',
  'cfg.area.categories.summary': 'إصدار السياسة {version} · {active} أنواع نشطة',
  'cfg.area.purposes': 'أغراض الزيارة',
  'cfg.area.purposes.hint': 'القائمة التي يختار منها المضيفون حين يطلبها نوع الزائر.',
  'cfg.area.purposes.summary': '{active} مستخدمة · {retired} موقوفة',
  'cfg.area.id_types': 'أنواع هوية الزائر',
  'cfg.area.id_types.hint': 'وثائق الهوية المقبولة (إعدادات التحقق من الهوية).',
  'cfg.area.id_types.summary': '{enabled} مقبولة · {disabled} غير مقبولة · إصدار الإعدادات {version}',
  'cfg.area.qr': 'التصريح وإعادة الدخول',
  'cfg.area.qr.hint': 'إعادة الدخول بعد المغادرة ونافذة الوصول المبكر (قواعد الاستقبال في سياسة الزوار).',
  'cfg.area.qr.summary': 'إعادة الدخول بعد المغادرة: {reentryAfterCheckout} · الوصول المبكر {earlyArrivalMinutes} دقيقة',
  'cfg.area.session': 'تسجيل الدخول والجلسة',
  'cfg.area.session.hint': 'حدود الجلسة عند الخمول والحد المطلق ومتطلب المصادقة متعددة العوامل.',
  'cfg.area.session.summary': 'الخمول {idleMinutes} دقيقة · الحد المطلق {absoluteHours} ساعة · المصادقة متعددة العوامل: {mfa} · المصدر: {source}',
  'cfg.area.session.owner': 'يحددها مسؤول النظام؛ ويمكن للمؤسسات قراءتها.',
  'cfg.area.display': 'تنسيق التاريخ والوقت',
  'cfg.area.display.hint': 'كيف تظهر التواريخ والأوقات لكل من في المؤسسة.',
  'cfg.area.display.summary': '{dateStyle} · {hourCycle}',
  'cfg.value.yes': 'نعم',
  'cfg.value.no': 'لا',
  'cfg.value.none': 'غير مطلوبة',
  'cfg.value.administrators': 'المسؤولون',
  'cfg.value.all': 'الجميع',
  'cfg.value.platform': 'الافتراضي للمنصة',
  'cfg.value.organisation': 'المؤسسة',
  'cfg.value.medium': 'تاريخ متوسط',
  'cfg.value.long': 'تاريخ طويل',
  'cfg.value.numeric': 'تاريخ رقمي',
  'cfg.value.iso': 'تاريخ ISO',
  'cfg.value.locale': 'ساعة اللغة',
  'cfg.value.h23': 'نظام 24 ساعة',
  'cfg.value.h12': 'نظام 12 ساعة',
  'cfg.purpose.intro': 'قيم للاستخدام على مستوى المؤسسة أو لموقع واحد. تحل قيمة الموقع ذات الرمز نفسه محل قيمة المؤسسة في ذلك الموقع.',
  'cfg.purpose.new': 'غرض جديد',
  'cfg.purpose.editTitle': 'تعديل الغرض',
  'cfg.purpose.dialogHint': 'لا يتغير الرمز أبدًا. يمكن تعديل التسميات وأنواع الزوار؛ وتحتفظ الزيارات بالنص الذي حُفظت به.',
  'cfg.purpose.empty': 'لا توجد أغراض بعد. تستخدم أنواع الزوار نصًا حرًا حتى توجد قائمة.',
  'cfg.purpose.col.purpose': 'الغرض',
  'cfg.purpose.col.scope': 'ينطبق على',
  'cfg.purpose.col.types': 'أنواع الزوار',
  'cfg.purpose.col.status': 'الحالة',
  'cfg.purpose.everySite': 'كل المواقع',
  'cfg.purpose.everyType': 'كل الأنواع',
  'cfg.purpose.active': 'مستخدم',
  'cfg.purpose.retired': 'موقوف',
  'cfg.purpose.retire': 'إيقاف',
  'cfg.purpose.restore': 'إعادة',
  'cfg.purpose.usedBy': { zero: 'لا تحمله أي زيارة', one: 'تحمله زيارة واحدة', two: 'تحمله زيارتان', few: 'تحمله {count} زيارات', many: 'تحمله {count} زيارة', other: 'تحمله {count} زيارة' },
  'cfg.purpose.historyNote': 'إيقاف الغرض يبقيه في الزيارات التي تحمله، لكن لا يمكن اختياره مجددًا حتى تتم إعادته.',
  'cfg.purpose.code': 'الرمز',
  'cfg.purpose.codeHint': 'أحرف لاتينية صغيرة وأرقام وشرطة أو شرطة سفلية، مثل site_meeting.',
  'cfg.purpose.labelEn': 'التسمية (بالإنجليزية)',
  'cfg.purpose.labelAr': 'التسمية (بالعربية)',
  'cfg.purpose.typesHint': 'رموز أنواع الزوار مفصولة بفواصل؛ اتركه فارغًا لكل الأنواع.',
  'cfg.purpose.modeLabel': 'غرض الزيارة',
  'cfg.purpose.modeHint': 'تُدار القوائم في إعدادات المؤسسة.',
  'cfg.purpose.mode.free': 'نص حر',
  'cfg.purpose.mode.list': 'من قائمة الأغراض فقط',
  'cfg.purpose.mode.list_or_other': 'من القائمة أو غير ذلك',
  'cfg.purpose.choose': 'اختر غرضًا…',
  'cfg.purpose.other': 'غير ذلك (صف الغرض)',
  'cfg.purpose.otherText': 'صف الغرض',
  'cfg.purpose.listOnly': 'يُختار غرض زوار هذا النوع من القائمة.',
  'cfg.purpose.listOrOther': 'اختر من القائمة، أو «غير ذلك» لوصفه.',
  'cfg.purpose.retiredOption': '{name} (موقوف — محفوظ لهذه الزيارة)',
  'cfg.display.intro': 'يُطبَّق على كل الشاشات والتصديرات لأفراد هذه المؤسسة. وتبقى لغة كل شخص هي التي تحدد الكلمات والأرقام.',
  'cfg.display.dateStyle': 'نمط التاريخ',
  'cfg.display.clock': 'الساعة',
  'cfg.display.date.medium': 'متوسط (7 أكتوبر 2026)',
  'cfg.display.date.long': 'طويل (7 أكتوبر 2026 كاملًا)',
  'cfg.display.date.numeric': 'رقمي (07/10/2026)',
  'cfg.display.date.iso': 'ISO ‏(2026-10-07)',
  'cfg.display.clock.locale': 'حسب تفضيل اللغة',
  'cfg.display.clock.h23': 'نظام 24 ساعة',
  'cfg.display.clock.h12': 'نظام 12 ساعة',
  'cfg.display.preview': 'معاينة:',
  'cfg.display.note': 'تُعرض الأوقات دائمًا بالمنطقة الزمنية للموقع.',
  // مكاتب الاستقبال (OR-16، PD-057).
  'desk.label': 'مكتبك',
  'desk.none': 'بلا مكتب',
  'desk.hint': 'يحدد مكان تسجيل الوصول والمغادرة. ولا يغيّر ما يُسمح لك به.',
  'desk.recordedAt': 'في {desk}',
  // الزوار عبر المواقع (PB-12-08، PD-058).
  'xsite.label': 'الزوار المعروفون في مواقع أخرى',
  'xsite.hint': 'عندما يضيف مضيف شخصًا يراه بالفعل من موقع آخر. تكون الموافقات والفحوص جديدة دائمًا لهذا الموقع؛ ولا ينتقل سجل الزيارات أبدًا.',
  'xsite.identity': 'إعادة استخدام الاسم وبيانات الاتصال فقط',
  'xsite.identity_and_organisation': 'إعادة استخدام الاسم وبيانات الاتصال والجهة',
  'xsite.off': 'عدم إعادة الاستخدام — أضفه كزائر جديد',
  // وضع التشغيل وأساس قرار الدخول (PB-02-01، PB-02-04، PB-02-07؛ PD-059).
  'rcp.d.basis': 'تم الحكم وفق إصدار سياسة الزوار {version}، وقُرئت الحقائق في {when}.',
  'rcp.d.basisNoPolicy': 'قُرئت الحقائق في {when}.',
  'mode.title': 'وضع التشغيل',
  'mode.standalone': 'يعمل Passage بمفرده: لا يعتمد على أي نظام خارجي مباشر. يمكن تخطيط كل زيارة والموافقة عليها واستقبالها وإغلاقها بمتصفح أو جهاز لوحي.',
  'mode.integrated': 'بعض التكاملات المباشرة متصلة. إذا تعذّر أحدها، تستمر الزيارة بالمسار المساعد الموضح، وتُسجَّل النتيجة على أنها غير معروفة، لا ناجحة.',
  'mode.badge.standalone': 'مستقل',
  'mode.badge.integrated': 'متكامل',
  'mode.col.family': 'التكامل',
  'mode.col.state': 'المتصل',
  'mode.col.fallback': 'عند غيابه أو تعذّره',
  'mode.none': 'لا شيء',
  'mode.live': { zero: 'لا اتصالات مباشرة', one: 'اتصال مباشر واحد', two: 'اتصالان مباشران', few: '{count} اتصالات مباشرة', many: '{count} اتصالًا مباشرًا', other: '{count} اتصال مباشر' },
  'mode.simulated': { zero: 'لا محاكيات', one: 'محاكٍ واحد (للتطوير فقط)', two: 'محاكيان (للتطوير فقط)', few: '{count} محاكيات (للتطوير فقط)', many: '{count} محاكيًا (للتطوير فقط)', other: '{count} محاكٍ (للتطوير فقط)' },
  'mode.messaging': 'آخر 7 أيام: {accepted} مقبولة، {notSent} لم تُرسل',
  'mode.family.access_control': 'التحكم في الدخول',
  'mode.family.sso': 'الدخول الموحد',
  'mode.family.directory': 'الدليل',
  'mode.family.identity_verification': 'التحقق من الهوية',
  'mode.family.calendars': 'التقويمات',
  'mode.family.presence_feeds': 'تغذيات البوابات والأجهزة',
  'mode.family.other_connectors': 'موصلات أخرى (الموارد البشرية، الطابعات)',
  'mode.family.messaging': 'البريد والرسائل النصية وواتساب',
  'mode.fallback.access_control': 'يصدر الاستقبال شارات أو بطاقات ورقية يدويًا؛ وتبقى بيانات الاعتماد «غير مطلوبة».',
  'mode.fallback.sso': 'يسجّل الأشخاص الدخول بكلمة مرور Passage والمصادقة متعددة العوامل.',
  'mode.fallback.directory': 'يدير المسؤولون المستخدمين والمضيفين في Passage.',
  'mode.fallback.identity_verification': 'يتحقق موظف من الوثيقة يدويًا؛ ولا يُعلَّم شيء كمُتحقَّق تلقائيًا.',
  'mode.fallback.calendars': 'يخطط المضيفون الزيارات في Passage.',
  'mode.fallback.presence_feeds': 'يسجّل الاستقبال والأكشاك الوصول والمغادرة.',
  'mode.fallback.other_connectors': 'ينجز الموظفون المهمة يدويًا.',
  'mode.fallback.messaging': 'يشارك الاستقبال رابط التصريح أو المرجع شخصيًا؛ وتظهر الرسائل غير المرسلة في سجل التسليم.',
  // إرشادات الوصول (PB-13-09، PD-060).
  'guide.field.gate': 'البوابة',
  'guide.field.parking': 'المواقف',
  'guide.field.building': 'المبنى',
  'guide.field.floor': 'الطابق',
  'guide.field.route': 'المسار',
  'guide.field.contact': 'التواصل',
  'guide.tab': 'إرشادات الوصول',
  'guide.title': 'إرشادات الوصول',
  'guide.intro': 'إرشادات البوابة والمواقف والمبنى والطابق والمسار والتواصل للزوار. حدّدها لنوع زائر أو لوجهة؛ وتُطبَّق الإرشادات الأكثر تحديدًا لكل بند.',
  'guide.new': 'نشر الإرشادات',
  'guide.replace': 'نشر إصدار جديد',
  'guide.replaceTitle': 'نشر إصدار جديد',
  'guide.retire': 'إيقاف',
  'guide.history': 'إظهار الإصدارات السابقة',
  'guide.empty': 'لا توجد إرشادات بعد. تستخدم الدعوات والتصاريح تعليمات الموقع فقط.',
  'guide.version': 'الإصدار {number}',
  'guide.status.published': 'سارية',
  'guide.status.retired': 'موقوفة',
  'guide.historyNote': 'الإرشادات المنشورة لا تتغير ولا تُحذف: يحل إصدار جديد محلها للدعوات والتصاريح المستقبلية، وتبقى الإصدارات السابقة هنا للرسائل المرسلة.',
  'guide.dialogHint': 'اترك البند فارغًا ليُورث من إرشادات أوسع (مثل الموقع بالكامل).',
  'guide.scopeType': 'نوع الزائر',
  'guide.scopeTypeHint': 'تحصل زيارات هذا النوع فقط على هذه الإرشادات.',
  'guide.scopeLocation': 'الوجهة',
  'guide.scopeLocationHint': 'الزيارات إلى هذا الموقع أو أي مكان داخله.',
  'guide.scope.anyType': 'كل أنواع الزوار',
  'guide.scope.wholeSite': 'الموقع بالكامل',
  'guide.scope.type': 'النوع {code}',
  'guide.scope.location': 'في {name}',
  'guide.en': 'بالإنجليزية',
  'guide.ar': 'بالعربية',
  'guide.note': 'سبب التغيير (اختياري)',
  'guide.publish': 'نشر',
  'guide.visitTitle': 'إرشادات الوصول',
  'guide.visitIntro': 'ما يُبلَّغ به زوار هذه الزيارة عن طريقة الوصول.',
  // إزالة سياسة الموقع (PB-12-05، PD-062).
  'override.remove': 'إزالة سياسة الموقع',
  'override.title': 'إزالة السياسة الخاصة بهذا الموقع',
  'override.subtitle': 'ستُطبَّق سياسة المؤسسة المشتركة هنا. تحقّق مما سيتغير أولًا.',
  'override.from': 'يحل إصدار السياسة المشتركة {shared} محل إصدار سياسة الموقع {site}.',
  'override.added': 'أنواع الزوار التي تظهر',
  'override.removed': 'أنواع الزوار التي تختفي',
  'override.changed': 'أنواع الزوار التي تتغير قواعدها',
  'override.sections': 'قواعد أخرى تتغير',
  'override.none': 'لا شيء',
  'override.history': 'تحتفظ الزيارات المخططة بإصدار السياسة الذي قُررت بموجبه. وتبقى سياسة الموقع في سجل الإصدارات.',
  'override.reason': 'السبب',
  'override.confirm': 'الإزالة وتطبيق السياسة المشتركة',
  // أثر إيقاف الموقع (PB-12-04، PD-064).
  'loc.impact.visits': { zero: 'لا توجد زيارات مخططة تستخدم هذا الموقع.', one: 'زيارة مخططة واحدة تستخدم هذا الموقع.', two: 'زيارتان مخططتان تستخدمان هذا الموقع.', few: '{count} زيارات مخططة تستخدم هذا الموقع.', many: '{count} زيارة مخططة تستخدم هذا الموقع.', other: '{count} زيارة مخططة تستخدم هذا الموقع.' },
  'loc.impact.visitsBody': ' انقلها إلى وجهة أخرى أو ألغها أولًا.',
  'loc.impact.zones': { zero: 'لا يوجد ربط نشط لمناطق الدخول.', one: 'يوجد ربط نشط واحد لمنطقة دخول. عطّله أولًا.', two: 'يوجد ربطان نشطان لمناطق الدخول. عطّلهما أولًا.', few: 'يوجد {count} روابط نشطة لمناطق الدخول. عطّلها أولًا.', many: 'يوجد {count} ربطًا نشطًا لمناطق الدخول. عطّلها أولًا.', other: 'يوجد {count} ربط نشط لمناطق الدخول. عطّلها أولًا.' },
  'loc.impact.rules': 'ستتوقف هذه القواعد عن التطبيق هنا:',
  'loc.impact.rule.approver_group_member': 'عضو مجموعة الموافقين «{label}» المحدد بهذا الموقع',
  'loc.impact.rule.arrival_guidance': 'إرشادات الوصول {label} لهذا الموقع',
  'loc.impact.confirm': 'أفهم أن هذه القواعد ستتوقف عن التطبيق',
  'vform.overnight': 'زيارة ليلية: تنتهي هذه الزيارة في {date}.',
  'vform.gap': 'هذا الوقت غير موجود في {date} لأن الساعة تتقدم. اختر وقتًا:',
  'vform.gap.before': 'استخدم {time} (قبل التغيير)',
  'vform.gap.after': 'استخدم {time} (بعد التغيير)',
  'visits.overnight': 'ليلية',
  'visits.clockChange': 'يتغير التوقيت خلال هذه الزيارة ({from} ← {to})',
  'site.context.changed': 'تغيّر موقع عملك إلى {working}. هذه الصفحة تخص {page}؛ لن يُرسل شيء حتى تختار.',
  'site.context.switchBack': 'العودة إلى {site}',
  'site.context.restart': 'البدء من جديد في {site}',
  'visit.step.exception': 'يحتاج إلى متابعة',
  'vpolicy.cred.legend': 'بيانات اعتماد الدخول لهذا النوع من الزوار',
  'vpolicy.cred.issue': 'يمكن لزوار هذا النوع الحصول على بيانات اعتماد للدخول',
  'vpolicy.cred.enclosing': 'تضمين المناطق المؤدية إلى الوجهة (المبنى، الطابق)',
  'vpolicy.cred.common': 'تضمين المناطق المشتركة في الموقع',
  'vpolicy.cred.tokens': 'الحوامل المسموح بها لهذا النوع',
  'vpolicy.cred.token.card': 'بطاقة',
  'vpolicy.cred.token.pin': 'رمز PIN',
  'vpolicy.cred.token.qr': 'رمز QR',
  'vpolicy.cred.token.mobile': 'اعتماد عبر الهاتف',
  'vpolicy.cred.hint': 'هذه الإعدادات تضيّق فقط ما يسمح به الموقع؛ لا تضيف مناطق أو حوامل أبدًا.',
  'pv.rtype.title': 'الاحتفاظ حسب نوع الزائر',
  'pv.rtype.intro': 'يمكن لنوع الزائر الاحتفاظ بسجلات زياراته لمدة مختلفة عن قاعدة الفئة. تُحفظ في المسودة؛ انشر سياسة الاحتفاظ لتطبيقها.',
  'pv.rtype.none': 'لا يوجد نوع زائر له مدة احتفاظ خاصة. تنطبق قواعد الفئات أعلاه على كل زيارة.',
  'pv.rtype.type': 'رمز نوع الزائر',
  'pv.rtype.typeHint': 'الرمز من سياسة الزوار، مثل interview.',
  'pv.rtype.days': '{name}: عدد الأيام بعد انتهاء الزيارة',
  'pv.rtype.add': 'إضافة إلى المسودة',
  'pv.rtype.remove': 'إزالة',
  'pv.rtype.action': 'إجراء',
  'person.source': 'من {source}، {date}',
  'person.source.staff_entry': 'إدخال الموظفين',
  'person.source.walk_in': 'تسجيل حضور مباشر في الاستقبال',
  'person.source.visitor_self_service': 'الزائر',
  'person.source.record_import': 'استيراد سجلات',
  'person.source.roster_import': 'استيراد قائمة',
  'person.source.calendar': 'دعوة تقويم',
  'person.source.contractor_register': 'سجل المقاولين',
  'person.source.subject_request': 'طلب تصحيح خصوصية',
  'vform.noCreateHere': 'لا يمكنك تخطيط زيارات في {site}. اختر موقعًا يمكنك التخطيط فيه.',
  'vform.planAt': 'التخطيط في {site}',
};
